/* eslint-disable react-hooks/rules-of-hooks */
// @flow
import React, {useMemo, useState, useEffect, useCallback} from 'react';
import PropTypes from 'prop-types';
import {Redirect, Route, Switch, useHistory} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import {
  FREE_TRIAL_TIERS,
  LEGACY_TIERS,
  // PRO_TIERS,
  RENEWAL_BASIC_TIERS,
} from '../../../entities';
import type {
  Currency,
  Country,
  User,
  Store,
  Subscription,
  PaymentProvider,
  SubscriptionSetting,
} from '../../../entities';
import type {SubscribeRequest, PurchaseSummaryRequest} from '../api';
import {
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  makeStyles,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from '@material-ui/core';
import {
  ArrowBack,
  ArrowForwardIosRounded,
  CheckRounded,
  DeleteOutlined,
} from '@material-ui/icons';
import {colors} from '../../../assets/styles/colors';
import CustomTextField from '../../../elements/CustomTextField/CustomTextField';
import CustomButton from '../../../elements/CustomButton/CustomButton';
import DeleteConfirmationModal from '../../products/components/DeleteConfirmationModal/DeleteConfirmationModal';
import {commaFormat} from '../../../utils/number';
// import {persistItem, useLocalStorage} from '../../../utils/localStorage';
// const CUSTOMER_LOCAL_STORAGE_KEY = 'CUSTOMER';
import type {TierDetail} from '../../tiers/api';
import type {CardProfile, CheckoutSummary} from '../duck';
import type {ProcessorParameters} from '../api';
import PaymentFailureModal from './Modals/PaymentFailureModal';
import {getConfigurationAdmin} from '../../../utils/location';
import type {ConfigurationAdmin} from '../../../utils/location/api';
import {usePage} from '../../page/utils';
import CulqiPaymentButton from './Culqi/CulqiPaymentButton';
import PayUPaymentButton from './PayU/PayUPaymentButton';
import StripeCheckoutForm from './Stripe/StripeCheckoutForm';
import StripeCustomPaymentButton from './Stripe/StripeCustomPaymentButton';
import analytics from '../../../analytics';
import type {AccountConfigAction} from '../../profile/account/duck';
import {getStringDate} from '../../../utils/date';
import AddCardModal from './Modals/AddCardModal';
// import ChangeTierWithoutPmModal from './Modals/ChangeTierWithoutPmModal';
import {formatCardNumber, getCardBrandIcon} from '../../../utils/card';
import PlanChangeSuccessModal from './Modals/PlanChangeSuccessModal';
import queryString from 'query-string';
import type {CheckoutAction} from '../duck';
import {getCurrencyByCountry} from '../../on-boarding/utils';
import type {TiersListAction} from '../../tiers/duck';
import {useTypedSelector} from '../../../store';
import ConsentUpdateSettingModal from './Modals/ConsentUpdateSettingModal';
import SnackBar from '../../../elements/SnackBar/SnackBar';
import {TIENDADA_LINKS} from '../../../constants';
import {MAP_SINGLE_PLAN_NAME} from '../../store/utils/utils_tier';
import {useBindedAction} from '../../../utils/globalStore';

import {actions as TierActions} from '../../tiers/duck';
// import {useIsMinimalPlan} from '../../store/utils';

type Props = {
  currency?: Currency,
  // providers?: PaymentProvider[],
  store?: Store,
  isFetchingStore?: boolean,
  country?: Country,
  user?: User,
  // saveCulqiCard: ({createCardRequest: Object}) => void,
  isSaving?: boolean,
  fetchCards: () => void,
  cardProfiles?: CardProfile[],
  isFetchingCardProfiles?: boolean,
  deleteCard: ({cardId: string}) => void,
  // performCulqiCheckout: ({cardId: string, invoiceId: string}) => void,
  // isPerformingCheckout?: boolean,
  // performCheckoutSuccess?: boolean,
  // performCheckoutError?: string,
  fetchPurchaseSummary: ({
    purchaseSummaryRequest: PurchaseSummaryRequest,
  }) => void,
  fetchPurchaseSummaryError?: string,
  checkoutSummary?: CheckoutSummary,
  performSubscribe: ({subscribeRequest: SubscribeRequest}) => void,
  isSubscribing?: boolean,
  subscribeSuccess?: boolean,
  subscribeError?: string,
  checkoutResetState: () => void,
  planSelectedCurrency: string,
  planSelected?: TierDetail,
  setPlanSelected: ({plan: TierDetail}) => void,
  basicPlans?: TierDetail[],
  proPlusPlans?: TierDetail[],
  resetPlanSelected: () => void,
  subscription?: Subscription,
  paymentProviders?: PaymentProvider[],
  saveSubscriptionSetting: (payload: AccountConfigAction) => void,
  isSavingSubscriptionSetting?: boolean,
  saveSubscriptionSettingError?: string,
  saveSubscriptionSettingSuccess?: boolean,
  subscriptionSetting?: SubscriptionSetting,
  isFetchingSubscriptionSetting?: boolean,
  fetchPaymentProviders: (payload: CheckoutAction) => void,
  setPlanSelectedCurrency: (payload: TiersListAction) => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    background: '#F8F9FB',
  },
  navBackground: {
    [theme.breakpoints.down('sm')]: {
      background: 'white !important',
    },
  },
  headerWrapper: {
    padding: theme.spacing(4, 4, 0, 4),
    background: '#f8f9fb',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 4, 0, 4),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(3, 2, 0, 2),
      },
    },
  },
  dividerVertical: {
    margin: theme.spacing(0, 1),
    background: colors.grey300,
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'black',
  },
  backButton: {
    background: 'white',
    padding: '4px',
    margin: '0 16px 0 0',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  content: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    maxWidth: 1500,
    padding: theme.spacing(3, 4, 4, 4),
    [theme.breakpoints.only('sm')]: {
      marginBottom: 64,
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
      padding: theme.spacing(2, 2, 2, 2),
      marginBottom: 180,
    },
    // flexWrap: 'wrap',
  },
  contentColumn: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    background: 'white',
    borderRadius: '12px',
    padding: theme.spacing(2),
    marginRight: theme.spacing(4),
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      maxWidth: 'unset',
      marginRight: 'unset',
      marginBottom: theme.spacing(2),
    },
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    // width: 352,
    maxWidth: 352,
    '&:last-child': {
      marginRight: 'unset',
    },
  },
  columnContainer: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  contentTitle: {
    fontWeight: 600,
    fontSize: '1.125rem',
    marginBottom: theme.spacing(2),
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    marginTop: theme.spacing(1),
    width: 320,
    height: 152,
    maxWidth: '100%',
    border: `1px solid ${colors.grey300}`,
    borderRadius: '8px',
    padding: theme.spacing(2),
  },
  selectedCard: {
    border: `2px solid ${colors.purple2}`,
  },
  cardRadio: {
    padding: '0px 12px 8px 8px',
  },
  name: {
    fontWeight: 600,
    fontSize: '0.875rem',
    marginBottom: 8,
  },
  cardInfo: {
    fontSize: '0.875rem',
    color: colors.grey700,
    marginTop: 4,
  },
  cardButtons: {
    display: 'flex',
    marginTop: 'auto',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  seeMoreCardButton: {
    padding: '0px 13px',
    color: colors.purple3,
    backgroundColor: colors.lightPurple,
  },
  deleteCardButton: {
    padding: '0px 13px',
    color: colors.grey600,
    fontSize: '0.75rem',
  },
  otherCard: {
    alignSelf: 'center',
    marginTop: theme.spacing(1),
    width: 320,
    maxWidth: '100%',
    border: `1px solid ${colors.grey300}`,
    borderRadius: '8px',
    padding: theme.spacing(2),
  },
  otherCardRadio: {
    padding: '0px 12px 0px 8px',
  },
  otherCardText: {
    fontSize: '0.875rem',
    color: colors.grey700,
  },
  bottomSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  cancelButton: {
    marginTop: theme.spacing(2),
    fontWeight: 'normal',
    color: colors.grey600,
    textDecoration: 'underline',
  },
  radio: {
    margin: theme.spacing(1, 0),
  },
  divider: {
    background: colors.grey200,
    width: '100%',
  },
  textField: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
  selectWrapper: {
    marginBottom: theme.spacing(2),
  },
  checkbox: {
    padding: theme.spacing(1, 1, 1, 1),
  },
  checkboxLabel: {
    color: colors.grey700,
    fontSize: '0.875rem',
    // margin: theme.spacing(1, 0),
  },
  automaticChargeDisclaimer: {
    margin: theme.spacing(1, 0, 0, 0),
    color: colors.grey700,
    fontSize: '0.75rem',
  },
  checkoutSummary: {
    borderRadius: '8px',
    backgroundColor: colors.lightPurple,
    padding: theme.spacing(1, 2, 2, 2),
  },
  summaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1),
  },
  summaryTitle: {
    fontSize: '1rem',
    fontWeight: 600,
    color: colors.purple3,
  },
  summaryDivider: {
    marginTop: theme.spacing(1),
    background: colors.grey300,
    width: '100%',
  },
  bold: {
    fontSize: '0.875rem',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
  },
  semibold: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  strikethrough: {
    textDecoration: 'line-through',
    fontSize: '0.875rem',
    // marginRight: theme.spacing(1),
  },
  discount: {
    fontSize: '0.75rem',
  },
  couponTextField: {
    marginTop: theme.spacing(3),
  },
  couponTextFieldLabel: {
    fontSize: '0.875rem',
  },
  applyCouponButton: {
    color: colors.purple3,
    textDecoration: 'underline',
  },
  deleteCouponButton: {
    color: colors.error,
  },
  couponApplication: {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: colors.grey600,
    textAlign: 'right',
    margin: theme.spacing(1, 1, 0, 1),
  },
  appliedCoupon: {
    color: colors.success,
  },
  invalidCoupon: {
    color: colors.error,
  },
  termsNConditionsCheckbox: {
    margin: theme.spacing(0, 0, 1, 1),
  },
  contactButton: {
    margin: theme.spacing(-5, 5, 0, 1),
    fontWeight: 'normal',
    color: colors.purple3,
    textDecoration: 'underline',
    whiteSpace: 'pre-wrap',
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(-2, 1, 0, 1),
    },
  },
  planChangeContent: {
    // flex: 1,
    // display: 'flex',
    // flexDirection: 'column',
    background: 'white',
    borderRadius: '12px',
    padding: theme.spacing(4),
    // marginRight: theme.spacing(4),
    // marginBottom: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      maxWidth: 'unset',
      marginRight: 'unset',
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2),
    },
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    width: 800,
    maxWidth: '100%',
    // width: 352,
    // maxWidth: 352,
    // '&:last-child': {
    //   marginRight: 'unset',
    // },
  },
  fromPlan: {
    color: colors.grey900,
  },
  bigArrow: {
    margin: theme.spacing(2, 2, 0, 2),
    fontSize: '1.75rem',
    color: colors.grey600,
  },
  toPlan: {
    color: colors.purple3,
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  smallText: {
    fontSize: '0.875rem',
  },
  paymentDateAlert: {
    marginTop: theme.spacing(-2),
    marginLeft: 'auto',
    marginBottom: theme.spacing(2),
    padding: 12,
    maxWidth: 360,
    height: '100%',
    borderRadius: '5px',
    border: `1px solid ${colors.purple3}`,
    background: colors.lightPurple,
  },
  paymentDateAlertTitle: {
    fontSize: '0.75rem',
    fontWeight: 700,
  },
  paymentDateAlertText: {
    fontSize: '0.75rem',
  },
  radioRoot: {
    marginTop: theme.spacing(2),
  },
  planName: {
    fontSize: '1.5rem',
    lineHeight: '1.75rem',
    fontWeight: 600,
  },
  planLabelLine: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  planLabel: {
    marginRight: theme.spacing(1),
    fontSize: '1.25rem',
    fontWeight: 600,
  },
  planDescription: {marginRight: theme.spacing(1)},
  selectedPlanDescription: {
    fontWeight: 500,
  },
  recommendedPlanBadge: {
    background: colors.success,
    padding: '2px 8px',
    fontSize: '0.75rem',
    fontWeight: 500,
    color: 'white',
    borderRadius: '16px',
  },
  planSavings: {
    fontWeight: 600,
  },
  selectedPlanSavings: {
    color: colors.purple3,
    fontWeight: 700,
  },
  planChangeSummary: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    margin: theme.spacing(2, 2, 0, 2),
  },
  planChangeSummaryRow: {
    display: 'flex',
    alignItems: 'baseline',
    marginBottom: theme.spacing(1),
  },
  planChangeSummaryText: {
    marginLeft: theme.spacing(2),
    fontSize: '0.875rem',
    '&[data-text-green]': {
      color: colors.success,
    },
    // whiteSpace: 'nowrap',
  },
  planChangeSummaryNumber: {
    textAlign: 'right',
    width: 65,
    marginLeft: theme.spacing(2),
    fontSize: '0.875rem',
    // whiteSpace: 'nowrap',
  },
  planChangeSummaryDiscount: {
    textAlign: 'right',
    width: 65,
    marginLeft: theme.spacing(2),
    fontSize: '0.875rem',
    whiteSpace: 'nowrap',
    color: colors.success,
  },
  planChangeFullPrice: {
    textDecoration: 'line-through',
    fontSize: '20px',
    // fontWeight: 600,
    whiteSpace: 'nowrap',
    marginRight: theme.spacing(1),
  },
  planChangeTotal: {
    fontSize: '43px',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  encouragementMsg: {
    // maxWidth: 500,
    marginTop: theme.spacing(2),
    fontSize: '0.875rem',
    fontWeight: 500,
    whiteSpace: 'pre-line',
  },
  changeSubscriptionButton: {
    marginTop: theme.spacing(3),
    width: 400,
    maxWidth: '100%',
    height: 48,
    fontSize: '1.125rem',
  },
  nextPaymentInfo: {
    marginTop: theme.spacing(3),
    fontSize: '0.875rem',
    color: colors.grey900,
  },
  planChangeRightSide: {
    margin: theme.spacing(3),
    width: 264,
  },
  featureLine: {
    marginTop: theme.spacing(2),
    display: 'flex',
  },
  checkIcon: {
    fontSize: '1.25rem',
  },
  featureText: {
    marginLeft: 4,
    fontSize: '0.875rem',
  },
}));

export default usePage<Props>(Checkout, 'Checkout');

function Checkout(props: Props) {
  const {
    // currency,
    user,
    store,
    isFetchingStore,
    country: storeCountry,
    // saveCulqiCard,
    // isSaving,
    fetchCards,
    cardProfiles,
    isFetchingCardProfiles,
    deleteCard,
    fetchPurchaseSummary,
    checkoutSummary,
    fetchPurchaseSummaryError,
    // performCulqiCheckout,
    // isPerformingCheckout,
    // performCheckoutSuccess,
    // performCheckoutError,
    performSubscribe,
    isSubscribing,
    subscribeSuccess,
    subscribeError,
    checkoutResetState,
    planSelectedCurrency,
    planSelected,
    setPlanSelected,
    basicPlans,
    proPlusPlans,
    resetPlanSelected,
    paymentProviders,
    subscription,
    saveSubscriptionSetting,
    isSavingSubscriptionSetting,
    saveSubscriptionSettingError,
    saveSubscriptionSettingSuccess,
    subscriptionSetting,
    isFetchingSubscriptionSetting,
    fetchPaymentProviders,
    setPlanSelectedCurrency,
  } = props;

  const classes = useStyles();
  const history = useHistory();
  const queryObject = queryString.parse(history.location.search);

  // const isMinimalPlan = useIsMinimalPlan();

  const shouldHideMonthlyPlan = true;

  const [isConsentModalOpen, setIsConsentModalOpen] = useState<boolean>(false);
  const creationRequest = useTypedSelector(
    state => state.referral.creationRequest
  );

  const [
    updateSettingRequest,
    setUpdateSettingRequest,
  ] = useState<CheckoutAction | null>(null);

  const fetchSubscriptionInformation = useBindedAction(
    TierActions.fetchSubscriptionInformation
  );

  // const basicPlans = useMemo(() => {
  //   if (bPlans) {
  //     if (shouldHideMonthlyPlan) {
  //       return bPlans.filter(p => p.frequency?.months !== 1);
  //     } else return bPlans;
  //   }
  // }, [bPlans, shouldHideMonthlyPlan]);

  // const proPlusPlans = useMemo(() => {
  //   if (pPlans) {
  //     if (shouldHideMonthlyPlan) {
  //       return pPlans.filter(p => p.frequency?.months !== 1);
  //     } else return pPlans;
  //   }
  // }, [pPlans, shouldHideMonthlyPlan]);

  const subscriptionAttempt =
    subscription &&
    !subscription.autoGenerated &&
    subscription.state === 'PENDING';

  //Next plan tier basdo en storeTierPlan del subscriptionSetting
  const nextPlanTier =
    !subscriptionAttempt &&
    !!subscription &&
    !!subscriptionSetting &&
    !!subscriptionSetting.storeTierPlan &&
    !!subscriptionSetting.automaticCharge
      ? subscriptionSetting.storeTierPlan.storeTier.name
      : !!store && store.storeTier.name;

  const isOnlyFreeTrial =
    !!store &&
    (FREE_TRIAL_TIERS.includes(store.storeTier.name) ||
      'TIER_11' === store.storeTier.name);

  const nextPlanFrequency =
    !subscriptionAttempt &&
    subscription &&
    subscriptionSetting &&
    (!!subscriptionSetting.storeTierPlan &&
    !!subscriptionSetting.automaticCharge
      ? subscriptionSetting.storeTierPlan.frequency.name
      : subscription.storeTierPlan.frequency.name);

  useEffect(() => {
    return () => {
      resetPlanSelected();
      checkoutResetState();
    };
  }, [checkoutResetState, resetPlanSelected]);

  const {
    register,
    handleSubmit,
    errors,
    formState,
    watch,
    reset,
    setValue,
  } = useForm({
    mode: 'onChange',
    shouldUnregister: false,
  });
  const {isValid} = formState;

  useEffect(() => {
    fetchCards();
  }, [fetchCards]);

  const pricing = useMemo(() => {
    if (planSelected && planSelected.prices) {
      if (planSelectedCurrency)
        for (let i = 0; i < planSelected.prices.length; i++) {
          if (planSelected.prices[i].currency.code === planSelectedCurrency) {
            if (planSelectedCurrency === 'PEN' && planSelected.frequency)
              // HARDCODED PERU PRICES
              return {
                ...planSelected.prices[i],
                price: {MONTHLY: '52.9', QUARTERLY: '129.9', ANNUAL: '414.9'}[
                  planSelected.frequency.name
                ],
              };
            return planSelected.prices[i];
          }
        }
      else {
        for (let i = 0; i < planSelected.prices.length; i++) {
          if (planSelected.prices[i].currency.code === 'USD')
            return planSelected.prices[i];
        }
      }
    }
  }, [planSelected, planSelectedCurrency]);

  const realPricing = useMemo(() => {
    if (planSelected && planSelected.prices) {
      if (planSelectedCurrency)
        for (let i = 0; i < planSelected.prices.length; i++) {
          if (
            planSelectedCurrency === 'PEN'
              ? planSelected.prices[i].currency.code === 'USD'
              : planSelected.prices[i].currency.code === planSelectedCurrency
          ) {
            return planSelected.prices[i];
          }
        }
      else {
        for (let i = 0; i < planSelected.prices.length; i++) {
          if (planSelected.prices[i].currency.code === 'USD')
            return planSelected.prices[i];
        }
      }
    }
  }, [planSelected, planSelectedCurrency]);

  const paymentProvider = useMemo(() => {
    if (planSelectedCurrency && paymentProviders && paymentProviders.length) {
      for (let i = 0; i < paymentProviders.length; i++) {
        if (
          (planSelectedCurrency === 'PEN' && // HARDCODED PERU PRICES BUT USE USD STRIPE
            paymentProviders[i].currency.code === 'USD') ||
          paymentProviders[i].currency.code === planSelectedCurrency
        )
          return paymentProviders[i];
      }
    }
  }, [paymentProviders, planSelectedCurrency]);

  const compatibleCardProfiles = useMemo(() => {
    if (cardProfiles && paymentProvider) {
      // show only cards compatible with chosen paymentProvider
      // return cardProfiles.filter(
      //   card => card.paymentProviderId === paymentProvider.id
      // );

      // show all cards
      return cardProfiles.filter(card => true);
    }
  }, [cardProfiles, paymentProvider]);

  const [tipoComprobante, setTipoComprobante] = useState('BOLETA');
  const handleChangeComprobante = event => {
    reset({
      firstName: '',
      lastName: '',
      dni: '',
      razonSocial: '',
      ruc: '',
      phone: '',
      email: '',
      address: '',
      admin1: '',
      admin2: '',
      admin3: '',
    });
    setTipoComprobante(event.target.value);
  };

  const [selectedCard, setSelectedCard] = useState('');
  const handleChangeSelectedCard = event => {
    setSelectedCard(event.target.value);
  };
  // select enabled card by default unless coming from payment failure banner
  useEffect(() => {
    if (compatibleCardProfiles && !queryObject.u_o_c) {
      for (let i = 0; i < compatibleCardProfiles.length; i++) {
        if (compatibleCardProfiles[i].current) {
          setSelectedCard(compatibleCardProfiles[i].id);
        }
      }
    }
  }, [compatibleCardProfiles, queryObject.u_o_c]);

  const noCardSelected =
    !compatibleCardProfiles ||
    !compatibleCardProfiles.length ||
    !selectedCard ||
    selectedCard === 'NEW';

  // const [
  //   noSavedPaymentMethodModalOpen,
  //   setNoSavedPaymentMethodModalOpen,
  // ] = useState(false);
  const [addCardModalOpen, setAddCardModalOpen] = useState(false);

  const [useOldCheckout, setUseOldCheckout] = useState(false);
  const [radioSelected, setRadioSelected] = useState(0);
  const radioPlans = useMemo(() => {
    if (store && basicPlans && proPlusPlans) {
      if (planSelected) {
        if (RENEWAL_BASIC_TIERS.includes(planSelected.storeTier.name)) {
          const selectedIndex = basicPlans.findIndex(
            plan => plan.id === planSelected.id
          );
          setRadioSelected(selectedIndex);
          return basicPlans;
        } else if (planSelected.storeTier.name === 'TIER_320') {
          const selectedIndex = proPlusPlans.findIndex(
            plan => plan.id === planSelected.id
          );
          setRadioSelected(selectedIndex);
          return proPlusPlans;
        } else return [];
      } else if (queryObject.plan_selected) {
        if (queryObject.u_o_c && queryObject.u_o_c === 'true') {
          // use old checkout
          setUseOldCheckout(true);
          setSelectedCard('NEW');
        }
        let selectedIndex = -1;
        selectedIndex = basicPlans.findIndex(
          plan => plan.id === queryObject.plan_selected
        );
        if (selectedIndex > -1) {
          // history.replace({search: ''});
          return basicPlans;
        } else {
          selectedIndex = proPlusPlans.findIndex(
            plan => plan.id === queryObject.plan_selected
          );
          if (selectedIndex > -1) {
            // history.replace({search: ''});
            return proPlusPlans;
          } else return [];
        }
      } else return [];
    } else return [];
  }, [
    basicPlans,
    planSelected,
    proPlusPlans,
    queryObject.plan_selected,
    queryObject.u_o_c,
    store,
  ]);

  const isCouponApplied = useMemo(
    () => checkoutSummary && checkoutSummary.discount && checkoutSummary.coupon,
    [checkoutSummary]
  );

  useEffect(() => {
    if (!planSelected) {
      if (!queryObject.plan_selected) history.replace('/tiers-list');
      else if (radioPlans && radioPlans.length && planSelectedCurrency) {
        const plan = radioPlans.find(
          plan => plan.id === queryObject.plan_selected
        );
        if (plan) {
          setPlanSelected({plan});
          saveSubscriptionSetting({
            accountConfigRequest: {
              automaticCharge: true,
              storeTierPlanId: plan.id,
              currency: planSelectedCurrency,
            },
          });
        } else history.replace('/tiers-list');
      }
    }
  }, [
    history,
    planSelected,
    planSelectedCurrency,
    queryObject.plan_selected,
    radioPlans,
    saveSubscriptionSetting,
    setPlanSelected,
  ]);

  const [subscribe, setSubscribe] = useState(true);
  const handleToggleSubscribe = event => {
    setSubscribe(event.target.checked);
  };
  const [saveInfo, setSaveInfo] = useState(true);
  const handleToggleSaveInfo = event => {
    setSaveInfo(event.target.checked);
  };

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [cardToDelete, setCardToDelete] = useState('');
  const handleDeleteModalOpen = (id: string) => {
    setDeleteModalOpen(true);
    setCardToDelete(id);
  };
  const handleDeleteModalClose = () => {
    setDeleteModalOpen(false);
    setCardToDelete('');
  };

  const country = storeCountry ? storeCountry.code : 'PE';

  useEffect(() => {
    if (country && !paymentProviders)
      fetchPaymentProviders({providersQuery: {country: country}});
  }, [country, fetchPaymentProviders, paymentProviders]);

  useEffect(() => {
    if (country && !planSelectedCurrency) {
      const c = getCurrencyByCountry(country);
      if (c && paymentProviders && paymentProviders.length) {
        for (let i = 0; i < paymentProviders.length; i++) {
          if (paymentProviders[i].currency.code === c) {
            setPlanSelectedCurrency({currency: c});
          }
        }
        setPlanSelectedCurrency({currency: 'USD'});
      }
    }
  }, [
    country,
    paymentProviders,
    planSelectedCurrency,
    setPlanSelectedCurrency,
  ]);

  const configAdmin: ConfigurationAdmin = getConfigurationAdmin(country);

  const firstChargeDate = useMemo(() => {
    if (!subscription) return;

    const today5AM = new Date(
      new Date(subscription.startDate).setUTCHours(5, 0, 0, 0)
    );

    return today5AM < subscription.startDate
      ? new Date(new Date(today5AM).setUTCDate(today5AM.getUTCDate() + 1))
      : today5AM;
  }, [subscription]);

  const isChargeLastDayOnDueDate = useMemo(() => {
    if (!subscription) return;

    return (
      subscription.state === 'PENDING' &&
      subscription.paymentDueDate &&
      firstChargeDate &&
      firstChargeDate.getTime() <
        new Date(subscription.paymentDueDate).getTime()
    );
  }, [firstChargeDate, subscription]);

  const shouldReactivateSubscription = useMemo(() => {
    if (!subscription || !subscriptionSetting) return false;
    const currentDateTimestamp = new Date().getTime();
    const endDateTimestamp = new Date(subscription.endDate).getTime();

    return (
      (currentDateTimestamp < endDateTimestamp &&
        subscriptionSetting.automaticCharge === false &&
        subscription.state === 'PAID') ||
      isChargeLastDayOnDueDate
    );
  }, [isChargeLastDayOnDueDate, subscription, subscriptionSetting]);

  const checkoutSummaryHandler = (processorParameters: ProcessorParameters) => {
    const handleFormSubmit = data => {
      const subscribeRequest: SubscribeRequest = {
        automaticCharge: subscribe,
        storeTierPlanId: planSelected && planSelected.id ? planSelected.id : '',
        coupon:
          checkoutSummary && checkoutSummary.coupon
            ? checkoutSummary.coupon
            : undefined,
        currency: planSelectedCurrency,
        paymentData:
          !selectedCard || selectedCard === 'NEW'
            ? {
                payWithCard: false,
                billingAddress: {
                  firstName: data.firstName,
                  lastName: data.lastName,
                  idNumber: data.idNumber,
                  // email: data.email,
                  // razonSocial:data.razonSocial,
                  // ruc:data.ruc,
                  address1: data.address,
                  country: country || '',
                  admin1: data.admin1,
                  admin2: data.admin2,
                  admin3: data.admin3,
                },
                paymentProviderId: paymentProvider
                  ? paymentProvider.id
                  : undefined,
                processorParameters: processorParameters,
                savePaymentInformation: saveInfo,
              }
            : {
                payWithCard: true,
                userCardProfileId:
                  !!selectedCard && selectedCard !== 'NEW'
                    ? selectedCard
                      ? selectedCard
                      : undefined
                    : undefined,
              },
      };
      if (checkoutSummary && checkoutSummary.acquisitionAction) {
        if (['UPDATE_SETTING'].includes(checkoutSummary.acquisitionAction)) {
          //Store has redeemed a store tier plan.
          if (creationRequest) {
            setIsConsentModalOpen(true);
            setUpdateSettingRequest({
              accountConfigRequest: {
                automaticCharge: subscribeRequest.automaticCharge,
                storeTierPlanId: subscribeRequest.storeTierPlanId,
                currency: subscribeRequest.currency,
              },
            });
          } else {
            saveSubscriptionSetting({
              accountConfigRequest: {
                automaticCharge: subscribeRequest.automaticCharge,
                storeTierPlanId: subscribeRequest.storeTierPlanId,
                currency: subscribeRequest.currency,
              },
            });
          }
        } else if (
          [
            'NEW_SUBSCRIPTION',
            'APPORTIONING',
            'FREE_TRIAL',
            'CHARGE_SUBSCRIPTION',
            'UPDATE_AND_CHARGE_SUBSCRIPTION',
          ].includes(checkoutSummary.acquisitionAction)
        ) {
          performSubscribe({subscribeRequest});
          fetchSubscriptionInformation();
        }
      }
    };
    handleSubmit(handleFormSubmit)();
  };

  const onSubmit = (processorParameters: ProcessorParameters) => {
    if (noCardSelected) {
      setAddCardModalOpen(true);
      return;
    }
    if (
      store &&
      planSelected &&
      nextPlanTier === planSelected.storeTier.name &&
      !isOnlyFreeTrial &&
      subscription &&
      nextPlanFrequency === planSelected.frequency.name
    ) {
      if (shouldReactivateSubscription) {
        // Realizar cobro
        if (isChargeLastDayOnDueDate)
          checkoutSummaryHandler(processorParameters);
        // Reactivar subscripcion
        else
          saveSubscriptionSetting({
            accountConfigRequest: {
              automaticCharge: true,
            },
          });
      } else {
        history.push('/tiers-list');
      }
    } else checkoutSummaryHandler(processorParameters);
  };

  const onUpdateSettingConfirm = useCallback(() => {
    if (updateSettingRequest) {
      setIsConsentModalOpen(false);
      saveSubscriptionSetting(updateSettingRequest);
    }
  }, [saveSubscriptionSetting, updateSettingRequest]);

  const [planChangeModalOpen, setPlanChangeModalOpen] = useState(false);
  useEffect(() => {
    if (
      (saveSubscriptionSettingSuccess &&
        subscriptionSetting?.automaticCharge &&
        subscription &&
        (subscription.state === 'PAID' || subscription.autoGenerated) &&
        subscriptionSetting &&
        subscriptionSetting.storeTierPlan) ||
      (subscribeSuccess &&
        subscription &&
        subscriptionSetting &&
        !isFetchingSubscriptionSetting &&
        !isFetchingStore &&
        subscriptionSetting?.automaticCharge &&
        subscriptionSetting.storeTierPlan &&
        subscriptionSetting.storeTierPlan.storeTier.name !==
          subscription.storeTierPlan.storeTier.name)
    ) {
      setPlanChangeModalOpen(true);
    } else setPlanChangeModalOpen(false);
  }, [
    isFetchingStore,
    isFetchingSubscriptionSetting,
    saveSubscriptionSettingSuccess,
    store,
    subscribeSuccess,
    subscription,
    subscriptionSetting,
  ]);

  useEffect(() => {
    if (
      window &&
      subscribeSuccess &&
      checkoutSummary &&
      checkoutSummary.acquisitionAction === 'CHARGE_SUBSCRIPTION'
    ) {
      const timeoutId = setTimeout(() => {
        window.location.reload(false);
      }, 2000);

      return () => clearTimeout(timeoutId);
    }
  }, [checkoutSummary, subscribeSuccess]);

  const [paymentFailureModal, setPaymentFailureModal] = useState(false);
  useEffect(() => {
    if (subscribeError) setPaymentFailureModal(true);
  }, [subscribeError]);

  const [termsNConditions, setTermsNConditions] = useState(true);

  const [isPaying, setIsPaying] = useState(false);

  const disableInput = useMemo(() => {
    if (isSubscribing || isPaying) return true;
    else return false;
  }, [isPaying, isSubscribing]);

  const disableButton = useMemo(() => {
    if (
      (selectedCard && selectedCard !== 'NEW') ||
      ((compatibleCardProfiles && compatibleCardProfiles.length
        ? selectedCard === 'NEW'
        : true) &&
        tipoComprobante &&
        isValid)
    )
      return false;
    else return true;
  }, [compatibleCardProfiles, isValid, selectedCard, tipoComprobante]);

  useEffect(() => {
    if (planSelected && planSelected.id && planSelectedCurrency) {
      fetchPurchaseSummary({
        purchaseSummaryRequest: {
          storeTierPlanId: planSelected.id,
          currency: planSelectedCurrency,
          coupon: (checkoutSummary && checkoutSummary.coupon) || undefined,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPurchaseSummary, planSelected, planSelectedCurrency]);

  const applyCoupon = e => {
    if (planSelected && planSelected.id && planSelectedCurrency)
      fetchPurchaseSummary({
        purchaseSummaryRequest: {
          storeTierPlanId: planSelected.id,
          currency: planSelectedCurrency,
          coupon: watch('coupon') || undefined,
        },
      });
  };

  const deleteCoupon = e => {
    setValue('coupon', '');
    if (planSelected && planSelected.id && planSelectedCurrency)
      fetchPurchaseSummary({
        purchaseSummaryRequest: {
          storeTierPlanId: planSelected.id,
          currency: planSelectedCurrency,
          coupon: undefined,
        },
      });
  };

  useEffect(() => {
    if (
      history.location.pathname === '/checkout' &&
      paymentProvider &&
      planSelected &&
      realPricing &&
      user
    ) {
      analytics.fireCustomEvent('Checkout Viewed', {
        category: 'Checkout Step',
        action: 'Viewed',
        payment_provider: paymentProvider.name || '',
        currency: realPricing.currency.code,
        price: realPricing.price,
        plan: planSelected.label,
        user_type: user.type,
      });
    }
  }, [history, paymentProvider, planSelected, realPricing, user]);

  useEffect(() => {
    if (
      history.location.pathname === '/checkout' &&
      paymentProvider &&
      planSelected &&
      realPricing &&
      user
    ) {
      analytics.fireCustomEvent('Checkout Started', {
        category: 'Checkout Step',
        action: 'Started',
        payment_provider: paymentProvider.name || '',
        currency: realPricing.currency.code,
        price: realPricing.price,
        plan: planSelected.label,
        user_type: user.type,
      });
    }
  }, [history, paymentProvider, planSelected, realPricing, user]);

  const infoForm = (
    <>
      <CustomTextField
        label="Nombres"
        name="firstName"
        className={classes.textField}
        // defaultValue={''}
        error={!!errors.firstName}
        helperText={errors.firstName ? errors.firstName.message : ''}
        inputRef={register({
          required: 'Campo obligatorio',
        })}
        type="text"
        disabled={disableInput}
      />
      <CustomTextField
        label="Apellidos"
        name="lastName"
        className={classes.textField}
        // defaultValue={''}
        error={!!errors.lastName}
        helperText={errors.lastName ? errors.lastName.message : ''}
        inputRef={register({
          required: 'Campo obligatorio',
        })}
        type="text"
        disabled={disableInput}
      />
      {tipoComprobante === 'BOLETA' && (
        <CustomTextField
          label="Documento de identidad"
          name="idNumber"
          className={classes.textField}
          // defaultValue={''}
          error={!!errors.idNumber}
          helperText={errors.idNumber ? errors.idNumber.message : ''}
          inputRef={register({
            required:
              tipoComprobante === 'BOLETA' ? 'Campo obligatorio' : false,
            // pattern: {
            //   value: /^[0-9]{8}$/i,
            //   message: 'Formato de DNI inválido',
            // },
          })}
          type="text"
          disabled={disableInput}
        />
      )}
      {tipoComprobante === 'FACTURA' && (
        <>
          <CustomTextField
            label="Razón Social"
            name="razonSocial"
            className={classes.textField}
            // defaultValue={''}
            error={!!errors.razonSocial}
            helperText={errors.razonSocial ? errors.razonSocial.message : ''}
            inputRef={register({
              required:
                tipoComprobante === 'FACTURA' ? 'Campo obligatorio' : false,
            })}
            type="text"
            disabled={disableInput}
          />
          <CustomTextField
            label="RUC"
            name="ruc"
            className={classes.textField}
            // defaultValue={''}
            error={!!errors.ruc}
            helperText={errors.ruc ? errors.ruc.message : ''}
            inputRef={register({
              required:
                tipoComprobante === 'FACTURA' ? 'Campo obligatorio' : false,
              pattern: {
                value: /^[0-9]{11}$/i,
                message: 'Formato de RUC inválido',
              },
            })}
            type="text"
            disabled={disableInput}
          />
        </>
      )}
      {/* <CustomTextField
        label="Número telefónico"
        name="phone"
        className={classes.textField}
        // defaultValue={''}
        error={!!errors.phone}
        helperText={errors.phone ? errors.phone.message : ''}
        inputRef={register({
          required: 'Campo obligatorio',
          pattern: {
            value: /^[0-9]{7,12}$/i,
            message: 'Formato de teléfono inválido',
          },
        })}
        type="text"
        disabled={disableInput}
      /> */}
      {/* <CustomTextField
        label="Correo electrónico"
        name="email"
        className={classes.textField}
        // defaultValue={''}
        error={!!errors.email}
        helperText={errors.email ? errors.email.message : ''}
        inputRef={register({
          required: 'Campo obligatorio',
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: 'Formato de email inválido',
          },
        })}
        type="text"
        disabled={disableInput}
      /> */}
      <CustomTextField
        label="Dirección"
        name="address"
        className={classes.textField}
        error={!!errors.address}
        helperText={errors.address ? errors.address.message : ''}
        inputRef={register({
          required: 'Campo obligatorio',
        })}
        type="text"
        disabled={disableInput}
      />
      {configAdmin.admin1.enabled && (
        <CustomTextField
          label={configAdmin.admin1.label}
          name="admin1"
          className={classes.textField}
          error={!!errors.admin1}
          helperText={errors.admin1 ? errors.admin1.message : ''}
          inputRef={register({
            required: 'Campo obligatorio',
          })}
          type="text"
          disabled={disableInput}
        />
      )}
      {configAdmin.admin2.enabled && (
        <CustomTextField
          label={configAdmin.admin2.label}
          name="admin2"
          className={classes.textField}
          error={!!errors.admin2}
          helperText={errors.admin2 ? errors.admin2.message : ''}
          inputRef={register({
            required: 'Campo obligatorio',
          })}
          type="text"
          disabled={disableInput}
        />
      )}
      {configAdmin.admin3.enabled && (
        <CustomTextField
          label={configAdmin.admin3.label}
          name="admin3"
          className={classes.textField}
          error={!!errors.admin3}
          helperText={errors.admin3 ? errors.admin3.message : ''}
          inputRef={register({
            required: 'Campo obligatorio',
          })}
          type="text"
          disabled={disableInput}
        />
      )}
    </>
  );

  const referencePrice = useMemo(() => {
    if (radioPlans) {
      const tierPricing = radioPlans.find(
        plan => plan.frequency && plan.frequency.name === 'MONTHLY'
      );

      if (radioPlans && tierPricing && tierPricing.prices) {
        if (planSelectedCurrency) {
          // if (planSelectedCurrency === 'PEN') return '52.9'; // HARDCODED PERU PRICES
          for (let i = 0; i < tierPricing.prices.length; i++) {
            if (tierPricing.prices[i].currency.code === planSelectedCurrency)
              return tierPricing.prices[i].price;
          }
        } else {
          for (let i = 0; i < tierPricing.prices.length; i++) {
            if (tierPricing.prices[i].currency.code === 'USD')
              return tierPricing.prices[i].price;
          }
        }
      }
    }
  }, [planSelectedCurrency, radioPlans]);

  return (
    <div className={classes.root}>
      <AddCardModal
        open={addCardModalOpen}
        handleClose={() => setAddCardModalOpen(false)}
        paymentProvider={paymentProvider}
      />
      {/* <ChangeTierWithoutPmModal
        open={noSavedPaymentMethodModalOpen}
        handleClose={() => setNoSavedPaymentMethodModalOpen(false)}
        handleConfirm={() => setAddCardModalOpen(true)}
      /> */}
      {planChangeModalOpen && <PlanChangeSuccessModal />}
      <SnackBar
        mode="error"
        message={
          saveSubscriptionSettingError ? 'Error al completar la acción.' : ''
        }
      />
      <div className={classes.headerWrapper}>
        <Typography className={classes.title}>
          <Switch>
            <Route exact path="/checkout">
              <IconButton
                className={classes.backButton}
                onClick={() => {
                  selectedCard === 'NEW'
                    ? setSelectedCard('')
                    : history.push('/tiers-list');
                }}
              >
                <ArrowBack />
              </IconButton>
            </Route>
            <Route path="/checkout/payment">
              <IconButton
                className={classes.backButton}
                onClick={() => history.push('/checkout')}
              >
                <ArrowBack />
              </IconButton>
            </Route>
          </Switch>
          Mis Pagos
        </Typography>
      </div>
      <div className={classes.content}>
        {typeof nextPlanTier === 'string' && !useOldCheckout && planSelected ? (
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              maxWidth: '100%',
              alignItems: 'flex-start',
            }}
          >
            <div className={classes.planChangeContent}>
              <div style={{display: 'flex', flexWrap: 'wrap'}}>
                <div className={classes.fromPlan}>
                  <Typography className={classes.smallText}>Desde</Typography>
                  <Typography className={classes.planName}>
                    {MAP_SINGLE_PLAN_NAME[nextPlanTier]}
                  </Typography>
                  <Typography
                    className={classes.smallText}
                    style={{marginRight: -8}}
                  >
                    {isOnlyFreeTrial ? 'Periodo de prueba' : ''}
                  </Typography>
                </div>
                <ArrowForwardIosRounded className={classes.bigArrow} />
                <div className={classes.toPlan}>
                  <Typography className={classes.smallText}>
                    Cambiar a
                  </Typography>
                  <Typography className={classes.planName}>
                    {
                      {
                        TIER_309: 'Básico',
                        TIER_310: 'Básico',
                        TIER_320: 'PRO+',
                      }[planSelected.storeTier.name]
                    }
                  </Typography>
                  <Typography className={classes.smallText}>
                    {
                      {
                        MONTHLY: 'Mensual',
                        QUARTERLY: 'Trimestral',
                        ANNUAL: 'Anual',
                      }[planSelected.frequency.name]
                    }
                  </Typography>
                </div>
                {checkoutSummary &&
                  subscription &&
                  ['UPDATE_SETTING'].includes(
                    checkoutSummary.acquisitionAction
                  ) && (
                    <div className={classes.paymentDateAlert}>
                      <Typography className={classes.paymentDateAlertTitle}>
                        Aviso
                      </Typography>
                      <Typography className={classes.paymentDateAlertText}>
                        Tu nuevo plan se cobrará el{' '}
                        {getStringDate(new Date(subscription.endDate))}. Debes
                        tener un método de pago configurado para proceder con la
                        elección de tu plan.
                      </Typography>
                    </div>
                  )}
              </div>
              <Divider className={classes.divider} />
              <Grid container>
                <Grid item xs={12} sm={8}>
                  <RadioGroup
                    name="planSelected"
                    value={radioSelected}
                    onChange={e => {
                      setRadioSelected(e.target.value);
                      setPlanSelected({plan: radioPlans[e.target.value]});
                    }}
                  >
                    {radioPlans &&
                      radioPlans
                        .filter(el =>
                          shouldHideMonthlyPlan
                            ? el.frequency?.months !== 1
                            : true
                        )
                        .map((tierPricing: TierDetail, index: number) => {
                          const totalReferencePrice =
                            tierPricing.frequency &&
                            tierPricing.frequency.months *
                              parseFloat(referencePrice);
                          let pricing = null;
                          if (tierPricing.prices) {
                            if (planSelectedCurrency)
                              for (
                                let i = 0;
                                i < tierPricing.prices.length;
                                i++
                              ) {
                                if (
                                  tierPricing.prices[i].currency.code ===
                                  planSelectedCurrency
                                ) {
                                  pricing = tierPricing.prices[i];
                                }
                              }
                            else {
                              for (
                                let i = 0;
                                i < tierPricing.prices.length;
                                i++
                              ) {
                                if (
                                  tierPricing.prices[i].currency.code === 'USD'
                                )
                                  pricing = tierPricing.prices[i];
                              }
                            }
                          }
                          return (
                            pricing && (
                              <React.Fragment key={index}>
                                <FormControlLabel
                                  classes={{
                                    root: classes.radioRoot,
                                    // label:
                                    //   paymentMethodSelected === pm.id
                                    //     ? classes.paymentMethodLabelSelected
                                    //     : '',
                                  }}
                                  value={index}
                                  control={<Radio color="primary" />}
                                  label={
                                    <>
                                      <div className={classes.planLabelLine}>
                                        <Typography
                                          className={classes.planLabel}
                                        >
                                          {tierPricing.label
                                            .replace('PRO+ ', '')
                                            .replace('Básico ', '')}
                                        </Typography>
                                        <Typography
                                          className={`${
                                            classes.planDescription
                                          }${
                                            radioSelected === index
                                              ? ' ' +
                                                classes.selectedPlanDescription
                                              : ''
                                          }`}
                                        >
                                          {`${
                                            nextPlanTier ===
                                              planSelected.storeTier.name &&
                                            !isOnlyFreeTrial &&
                                            subscription &&
                                            nextPlanFrequency ===
                                              tierPricing.frequency.name
                                              ? '(Plan Actual)'
                                              : ''
                                            // `- ${commaFormat(
                                            //     pricing.price,
                                            //     pricing.currency &&
                                            //       pricing.currency.symbol
                                            //   )} por ${
                                            //     tierPricing.frequency
                                            //       ? tierPricing.frequency.months
                                            //       : ''
                                            //   } ${
                                            //     tierPricing.frequency &&
                                            //     tierPricing.frequency.months ===
                                            //       1
                                            //       ? 'mes'
                                            //       : 'meses'
                                            //   }`
                                          }`}
                                          {tierPricing.frequency.months ===
                                            12 && (
                                            <div
                                              className={
                                                classes.recommendedPlanBadge
                                              }
                                            >
                                              Recomendado
                                            </div>
                                          )}
                                        </Typography>
                                      </div>
                                      <div className={classes.planLabelLine}>
                                        <Typography
                                          className={classes.planDescription}
                                        >
                                          {`${
                                            pricing
                                              ? commaFormat(
                                                  parseFloat(pricing.price) /
                                                    (tierPricing.frequency
                                                      ? tierPricing.frequency
                                                          .months
                                                      : 1),
                                                  pricing.currency &&
                                                    pricing.currency.symbol
                                                )
                                              : ''
                                          } al mes.`}
                                        </Typography>
                                        {!!totalReferencePrice &&
                                          pricing &&
                                          totalReferencePrice !==
                                            parseFloat(pricing.price) && (
                                            <Typography
                                              className={`${
                                                classes.planSavings
                                              }${
                                                radioSelected === index
                                                  ? ' ' +
                                                    classes.selectedPlanSavings
                                                  : ''
                                              }`}
                                            >
                                              {`Ahorra ${commaFormat(
                                                Math.trunc(
                                                  totalReferencePrice -
                                                    parseFloat(pricing.price)
                                                ),
                                                pricing.currency &&
                                                  pricing.currency.symbol
                                              )}`}
                                            </Typography>
                                          )}
                                      </div>
                                    </>
                                  }
                                />
                              </React.Fragment>
                            )
                          );
                        })}
                  </RadioGroup>
                </Grid>
                <Grid item xs={12} sm={4}>
                  {planSelected && pricing && checkoutSummary && (
                    <div className={classes.planChangeSummary}>
                      {checkoutSummary &&
                        (checkoutSummary.credit ||
                          checkoutSummary.discount) && (
                          <>
                            <div className={classes.planChangeSummaryRow}>
                              <Typography
                                className={classes.planChangeSummaryText}
                              >
                                Total a pagar:
                              </Typography>
                              <Typography
                                className={classes.planChangeSummaryNumber}
                              >
                                {commaFormat(
                                  parseFloat(checkoutSummary.subtotal) +
                                    (checkoutSummary.credit
                                      ? parseFloat(checkoutSummary.credit)
                                      : 0),
                                  pricing.currency.symbol
                                )}
                              </Typography>
                            </div>
                            {checkoutSummary.credit && (
                              <div className={classes.planChangeSummaryRow}>
                                <Typography
                                  className={classes.planChangeSummaryText}
                                >
                                  Crédito:
                                </Typography>
                                <Typography
                                  className={classes.planChangeSummaryNumber}
                                  id="prorate-explanation"
                                >
                                  -
                                  {commaFormat(
                                    checkoutSummary.credit,
                                    pricing.currency.symbol
                                  )}
                                </Typography>
                              </div>
                            )}
                            {!!checkoutSummary.discount &&
                              !!checkoutSummary.coupon && (
                                <div className={classes.planChangeSummaryRow}>
                                  <Typography
                                    className={
                                      classes.planChangeSummaryDiscount
                                    }
                                    style={{textTransform: 'uppercase'}}
                                  >
                                    {checkoutSummary.coupon}
                                  </Typography>
                                  <Typography
                                    className={
                                      classes.planChangeSummaryDiscount
                                    }
                                  >
                                    -
                                    {commaFormat(
                                      checkoutSummary.discount,
                                      pricing.currency.symbol
                                    )}
                                  </Typography>
                                </div>
                              )}
                            <br />
                          </>
                        )}
                      {subscription &&
                        checkoutSummary &&
                        ['UPDATE_SETTING'].includes(
                          checkoutSummary.acquisitionAction
                        ) && (
                          <div className={classes.planChangeSummaryRow}>
                            <Typography
                              className={classes.planChangeSummaryText}
                              style={{fontWeight: 500}}
                            >
                              {`Fecha de pago: ${getStringDate(
                                new Date(subscription.endDate)
                              )}`}
                            </Typography>
                          </div>
                        )}
                      {subscription && (
                        <div className={classes.planChangeSummaryRow}>
                          <Typography
                            className={classes.planChangeSummaryText}
                            data-text-green
                          >
                            {`${planSelected.label} hasta ${getStringDate(
                              // for upgrade from free trial to pro+
                              store &&
                                FREE_TRIAL_TIERS.includes(
                                  store.storeTier.name
                                ) &&
                                planSelected.storeTier.name === 'TIER_320'
                                ? new Date().setMonth(
                                    new Date().getMonth() +
                                      {MONTHLY: 1, QUARTERLY: 3, ANNUAL: 12}[
                                        planSelected.frequency.name
                                      ]
                                  )
                                : // for prorate from basic to pro
                                store &&
                                  RENEWAL_BASIC_TIERS.includes(
                                    store.storeTier.name
                                  ) &&
                                  planSelected.storeTier.name === 'TIER_320'
                                ? new Date(subscription.endDate)
                                : // anything else
                                  new Date(subscription.endDate).setMonth(
                                    new Date(subscription.endDate).getMonth() +
                                      {MONTHLY: 1, QUARTERLY: 3, ANNUAL: 12}[
                                        planSelected.frequency.name
                                      ]
                                  )
                            )}`}
                          </Typography>
                        </div>
                      )}
                      {!subscription && (
                        <div className={classes.planChangeSummaryRow}>
                          <Typography
                            className={classes.planChangeSummaryText}
                            data-text-green
                          >
                            {`${planSelected.label} hasta ${getStringDate(
                              new Date().setMonth(
                                new Date().getMonth() +
                                  {MONTHLY: 1, QUARTERLY: 3, ANNUAL: 12}[
                                    planSelected.frequency.name
                                  ]
                              )
                            )}`}
                          </Typography>
                        </div>
                      )}
                      <div className={classes.planChangeSummaryRow}>
                        {planSelected &&
                          checkoutSummary &&
                          (checkoutSummary.total === '0.00'
                            ? parseFloat(pricing.price) <
                              planSelected.frequency.months *
                                parseFloat(referencePrice)
                            : parseFloat(checkoutSummary.total) <
                              planSelected.frequency.months *
                                parseFloat(referencePrice)) && (
                            <Typography className={classes.planChangeFullPrice}>
                              {commaFormat(
                                planSelected.frequency.months *
                                  parseFloat(referencePrice),
                                pricing.currency.symbol
                              )}
                            </Typography>
                          )}
                        <Typography className={classes.planChangeTotal}>
                          {commaFormat(
                            checkoutSummary
                              ? ['UPDATE_SETTING'].includes(
                                  checkoutSummary.acquisitionAction
                                ) && pricing
                                ? pricing.price
                                : checkoutSummary.total
                              : pricing.price,
                            pricing.currency.symbol
                          )}
                        </Typography>
                      </div>
                      <div className={classes.planChangeSummaryRow}>
                        <Typography className={classes.planChangeSummaryText}>
                          {`x ${planSelected.frequency.months} ${
                            planSelected.frequency &&
                            planSelected.frequency.months === 1
                              ? 'mes'
                              : 'meses'
                          }`}
                        </Typography>
                      </div>
                    </div>
                  )}
                </Grid>
              </Grid>
              <br />
              <Divider className={classes.divider} />
              <CustomTextField
                disabled={isCouponApplied || isSubscribing || isPaying}
                label="¿Tienes un cupón de descuento?"
                name="coupon"
                className={classes.couponTextField}
                InputProps={{
                  endAdornment: (
                    <>
                      {checkoutSummary &&
                        !checkoutSummary.coupon &&
                        watch('coupon') && (
                          <CustomButton
                            className={classes.applyCouponButton}
                            onClick={applyCoupon}
                          >
                            Aplicar
                          </CustomButton>
                        )}
                      {checkoutSummary && checkoutSummary.coupon ? (
                        <CustomButton
                          className={classes.deleteCouponButton}
                          endIcon={<DeleteOutlined />}
                          onClick={deleteCoupon}
                        >
                          Eliminar
                        </CustomButton>
                      ) : null}
                    </>
                  ),
                }}
                InputLabelProps={{
                  className: classes.couponTextFieldLabel,
                }}
                error={!!errors.coupon}
                helperText={errors.coupon ? errors.coupon.message : ''}
                inputRef={register}
                type="text"
              />
              {checkoutSummary &&
                (!fetchPurchaseSummaryError ||
                  fetchPurchaseSummaryError === 'Coupon not found') && (
                  <Typography
                    className={`${classes.couponApplication} ${
                      fetchPurchaseSummaryError &&
                      fetchPurchaseSummaryError === 'Coupon not found'
                        ? classes.invalidCoupon
                        : checkoutSummary && checkoutSummary.discount
                        ? classes.appliedCoupon
                        : ''
                    }`}
                  >
                    {fetchPurchaseSummaryError &&
                    fetchPurchaseSummaryError === 'Coupon not found'
                      ? 'Cupón inválido'
                      : checkoutSummary.discount
                      ? 'Cupón aplicado'
                      : ''}
                  </Typography>
                )}
              <Typography
                className={classes.encouragementMsg}
                id="prorate-explanation"
              >
                {planSelected &&
                  nextPlanTier === planSelected.storeTier.name &&
                  !isOnlyFreeTrial &&
                  planSelected.frequency &&
                  nextPlanFrequency &&
                  {
                    MONTHLY: {
                      MONTHLY: '',
                      QUARTERLY:
                        '¡Buena elección! - Al cambiar el periodo, estas ahorrando 15% del costo. \nTu nuevo periodo de suscripción comenzará cuando finalize el actual.',
                      ANNUAL:
                        '¡Buena elección! - Al cambiar el periodo, estas ahorrando 35% del costo. \nTu nuevo periodo de suscripción comenzará cuando finalize el actual.',
                    },
                    QUARTERLY: {
                      MONTHLY:
                        '¿Estás seguro? - Al cambiar el periodo, estas perdiendo el ahorro obtenido por elegir un plan trimestral. \nTu nuevo periodo de suscripción comenzará cuando finalize el actual.',
                      QUARTERLY: '',
                      ANNUAL:
                        '¡Buena elección! - Al cambiar el periodo, estas ahorrando 35% del costo. \nTu nuevo periodo de suscripción comenzará cuando finalize el actual.',
                    },
                    ANNUAL: {
                      MONTHLY:
                        '¿Estás seguro? - Al cambiar el periodo, estas perdiendo el ahorro obtenido por elegir un plan anual. \nTu nuevo periodo de suscripción comenzará cuando finalize el actual.',
                      QUARTERLY:
                        '¿Estás seguro? - Al cambiar el periodo, estas perdiendo el ahorro obtenido por elegir un plan anual. \nTu nuevo periodo de suscripción comenzará cuando finalize el actual.',
                      ANNUAL: '',
                    },
                  }[nextPlanFrequency][planSelected.frequency.name]}
                {planSelected.storeTier.name === 'TIER_320' &&
                  `¡Súper! - Con el plan PRO+, tendrás las herramientas que necesitas para hacer crecer tu negocio. ${
                    checkoutSummary && pricing && checkoutSummary.credit
                      ? `\nTienes un crédito de ${commaFormat(
                          checkoutSummary.credit,
                          pricing.currency.symbol
                        )} que se aplicará a tu nuevo plan.`
                      : ''
                  }`}
                {nextPlanTier === 'TIER_320' &&
                  !isOnlyFreeTrial &&
                  RENEWAL_BASIC_TIERS.includes(planSelected.storeTier.name) &&
                  `Tu nuevo plan de suscripción comenzará cuando finalize el actual.`}
              </Typography>
              <CustomButton
                variant="contained"
                className={classes.changeSubscriptionButton}
                onClick={onSubmit}
              >
                {isSubscribing || isSavingSubscriptionSetting ? (
                  <CircularProgress
                    style={{alignSelf: 'center', color: 'white'}}
                  />
                ) : noCardSelected ? (
                  'Agregar método de pago'
                ) : // IF PLANSELECTED TIER IS SAME AS STORE TIER
                nextPlanTier === planSelected.storeTier.name &&
                  !isOnlyFreeTrial ? (
                  (!!subscription && nextPlanFrequency) ===
                  (!!planSelected && planSelected.frequency.name) ? (
                    shouldReactivateSubscription ? (
                      'Reactivar plan'
                    ) : (
                      'Mantener plan'
                    )
                  ) : (
                    'Cambiar periodo de suscripción'
                  )
                ) : // IF GOING FROM TIER_310 TO TIER_320
                RENEWAL_BASIC_TIERS.includes(nextPlanTier) &&
                  !isOnlyFreeTrial &&
                  planSelected.storeTier.name === 'TIER_320' &&
                  checkoutSummary &&
                  pricing ? (
                  `Pagar ${commaFormat(
                    checkoutSummary.total,
                    pricing.currency.symbol
                  )} y mejorar plan` // IF GOING FROM TIER_320 TO TIER_310
                ) : nextPlanTier === 'TIER_320' &&
                  !isOnlyFreeTrial &&
                  RENEWAL_BASIC_TIERS.includes(planSelected.storeTier.name) ? (
                  `Cambiar de suscripción a plan Básico`
                ) : // ANY OTHER STARTING TIER
                noCardSelected ? (
                  'Agregar método de pago'
                ) : RENEWAL_BASIC_TIERS.includes(
                    planSelected.storeTier.name
                  ) ? (
                  `Suscribirme a plan Básico`
                ) : planSelected.storeTier.name === 'TIER_320' ? (
                  `Suscribirme a plan PRO+`
                ) : (
                  ''
                )}
              </CustomButton>
              {subscription &&
                subscriptionSetting &&
                subscriptionSetting.automaticCharge && (
                  <Typography className={classes.nextPaymentInfo}>
                    *El siguiente pago es el{' '}
                    {getStringDate(subscription.endDate)} y se renovará
                    automáticamente con el nuevo periodo de suscripción.
                  </Typography>
                )}
            </div>
            <div className={classes.planChangeRightSide}>
              {planSelected.storeTier.name === 'TIER_320' && (
                <>
                  <Typography className={classes.planName} color="primary">
                    Plan PRO+
                  </Typography>
                  <div className={classes.featureLine}>
                    <CheckRounded
                      className={classes.checkIcon}
                      color="primary"
                    />
                    <Typography className={classes.featureText}>
                      Todo el Plan Básico
                    </Typography>
                  </div>
                  <div className={classes.featureLine}>
                    <CheckRounded
                      className={classes.checkIcon}
                      color="primary"
                    />
                    <Typography className={classes.featureText}>
                      Usa tu propio dominio
                    </Typography>
                  </div>
                  <div className={classes.featureLine}>
                    <CheckRounded
                      className={classes.checkIcon}
                      color="primary"
                    />
                    <Typography className={classes.featureText}>
                      Elige entre nuestras plantillas, customiza el tipo de
                      letra, tamaño de foto del producto y más.
                    </Typography>
                  </div>
                  <div className={classes.featureLine}>
                    <CheckRounded
                      className={classes.checkIcon}
                      color="primary"
                    />
                    <Typography className={classes.featureText}>
                      Crea diferentes usuarios para tu equipo y asigna permisos.
                    </Typography>
                  </div>
                  <div className={classes.featureLine}>
                    <CheckRounded
                      className={classes.checkIcon}
                      color="primary"
                    />
                    <Typography className={classes.featureText}>
                      CRM integrado por WhatsApp, categoriza clientes, filtra y
                      descarga la data.
                    </Typography>
                  </div>
                  <div className={classes.featureLine}>
                    <CheckRounded
                      className={classes.checkIcon}
                      color="primary"
                    />
                    <Typography className={classes.featureText}>
                      Integraciones con Facebook Pixel, Facebook API de
                      conversiones, Google analytics.
                    </Typography>
                  </div>
                  <br />
                  <br />
                </>
              )}
              <Typography style={{fontSize: '1.125rem', fontWeight: 600}}>
                ¿Tienes dudas?
              </Typography>
              <Typography style={{marginTop: 8, fontSize: '0.875rem'}}>
                Lee la{' '}
                <b>
                  <a
                    href="https://tiendadateam.notion.site/Gu-a-de-Cobros-TiendaDA-c7026c8ed8554d848f753900cf86b7d9"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    guía de cobros TiendaDa
                  </a>
                </b>{' '}
                o contacta a nuestro{' '}
                <b>
                  <a
                    href={TIENDADA_LINKS.customerSupport.general}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    equipo de soporte
                  </a>
                </b>
                .
              </Typography>
              <Typography
                style={{marginTop: 16, fontSize: '1.125rem', fontWeight: 600}}
              >
                Método de pago actual
              </Typography>
              <Select
                value={selectedCard}
                onChange={handleChangeSelectedCard}
                disableUnderline
              >
                {compatibleCardProfiles &&
                  compatibleCardProfiles.map(cardProfile => (
                    <MenuItem
                      style={{display: 'flex', alignItems: 'center'}}
                      key={cardProfile.id}
                      value={cardProfile.id}
                    >
                      <img
                        src={getCardBrandIcon(cardProfile.brand)}
                        alt={cardProfile.brand}
                        style={{marginRight: 8}}
                      ></img>
                      {formatCardNumber(cardProfile.displayName)}
                    </MenuItem>
                  ))}
              </Select>
            </div>
          </div>
        ) : (
          // LEGACY CHECKOUT
          <>
            <div className={classes.contentColumn}>
              <Switch>
                <Route exact path="/checkout">
                  {!!paymentProvider && paymentProvider.name === 'STRIPE' ? (
                    <Typography className={classes.contentTitle}>
                      1. Registra tus datos
                    </Typography>
                  ) : (
                    <Typography className={classes.contentTitle}>
                      Información de Pago
                    </Typography>
                  )}
                  {!isFetchingCardProfiles && (
                    <>
                      {compatibleCardProfiles &&
                      compatibleCardProfiles.length > 0 &&
                      selectedCard !== 'NEW' ? (
                        <RadioGroup
                          name="selectedCard"
                          value={selectedCard}
                          onChange={handleChangeSelectedCard}
                        >
                          {compatibleCardProfiles.map(card => (
                            <div
                              key={`card-${card.id}`}
                              className={`${classes.card} ${
                                selectedCard === card.id
                                  ? classes.selectedCard
                                  : ''
                              }`}
                            >
                              <FormControlLabel
                                classes={{label: classes.name}}
                                value={card.id}
                                control={
                                  <Radio
                                    className={classes.cardRadio}
                                    color="primary"
                                  />
                                }
                                label={`${card.firstName} ${card.lastName}`}
                              />
                              <Typography className={classes.cardInfo}>
                                {`ID: ${card.idNumber || '--'}`}
                              </Typography>
                              <Typography className={classes.cardInfo}>
                                {!!card.displayName &&
                                  `Número de tarjeta: ${formatCardNumber(
                                    card.displayName
                                  )}`}
                              </Typography>
                              <div className={classes.cardButtons}>
                                {/* <CustomButton
                      variant="contained"
                      color="default"
                      className={classes.seeMoreCardButton}
                      // onClick={() => handleDeleteModalOpen(card.id)}
                    >
                      Ver más
                    </CustomButton> */}
                                <div />
                                <CustomButton
                                  color="default"
                                  className={classes.deleteCardButton}
                                  onClick={() => handleDeleteModalOpen(card.id)}
                                >
                                  Eliminar
                                </CustomButton>
                              </div>
                            </div>
                          ))}
                          <div className={classes.otherCard}>
                            <FormControlLabel
                              classes={{label: classes.otherCardText}}
                              value={'NEW'}
                              control={
                                <Radio
                                  className={classes.otherCardRadio}
                                  color="primary"
                                />
                              }
                              label="Usar otra información de pago"
                            />
                          </div>
                        </RadioGroup>
                      ) : (
                        <RadioGroup
                          name="tipoComprobante"
                          value={tipoComprobante}
                          onChange={handleChangeComprobante}
                        >
                          {/* <FormControlLabel
                          value="BOLETA"
                          control={
                            <Radio className={classes.radio} color="primary" />
                          }
                          label="Boleta de Venta"
                        /> */}
                          {tipoComprobante === 'BOLETA' && infoForm}
                          {/* <Divider className={classes.divider} />
                      <FormControlLabel
                        value="FACTURA"
                        control={
                          <Radio className={classes.radio} color="primary" />
                        }
                        label="Factura de Venta"
                      />
                      {tipoComprobante === 'FACTURA' && infoForm} */}
                          {!!paymentProvider &&
                            paymentProvider.name !== 'PAYU_WEB' &&
                            paymentProvider.name !== 'STRIPE' && (
                              <>
                                {/* <Divider className={classes.divider} /> */}
                                <FormControlLabel
                                  classes={{label: classes.checkboxLabel}}
                                  control={
                                    <Checkbox
                                      className={classes.checkbox}
                                      checked={saveInfo}
                                      onChange={handleToggleSaveInfo}
                                      color="primary"
                                      disabled={disableInput}
                                    />
                                  }
                                  label="Guardar información"
                                />
                                <FormControlLabel
                                  classes={{label: classes.checkboxLabel}}
                                  control={
                                    <Checkbox
                                      className={classes.checkbox}
                                      checked={subscribe}
                                      onChange={handleToggleSubscribe}
                                      color="primary"
                                      disabled={disableInput}
                                    />
                                  }
                                  label="Renovar automáticamente"
                                />
                                <Typography
                                  className={classes.automaticChargeDisclaimer}
                                >
                                  Tu subscripción se renovará automáticamente
                                  para continuar utilizando TiendaDA
                                  {store &&
                                  LEGACY_TIERS.includes(store.storeTier.name)
                                    ? ' PRO'
                                    : ''}
                                  .
                                </Typography>
                              </>
                            )}
                        </RadioGroup>
                      )}
                    </>
                  )}
                  {/* <div className={classes.bottomSection} style={{marginTop: 120}}>
            <Divider className={classes.divider} />
            <CustomButton color="default" className={classes.cancelButton}>
              Cancelar los pagos recurrentes
            </CustomButton>
          </div> */}
                </Route>
                <Route path="/checkout/payment">
                  <Typography className={classes.contentTitle}>
                    2. Método de pago
                  </Typography>
                  {!!paymentProvider &&
                  !!store &&
                  paymentProvider.name === 'STRIPE' &&
                  pricing ? (
                    <>
                      <StripeCheckoutForm
                        paymentProvider={paymentProvider}
                        setIsPaying={setIsPaying}
                        disabled={disableInput}
                      />
                      <Typography className={classes.automaticChargeDisclaimer}>
                        *Tu subscripción se renovará automaticamente mes a mes.
                        Puedes cancelarla antes de empezar el nuevo periodo.
                      </Typography>
                    </>
                  ) : (
                    <Redirect to="/checkout" />
                  )}
                </Route>
              </Switch>
            </div>
            <div className={classes.columnContainer}>
              <div className={classes.contentColumn}>
                {planSelected && pricing && (
                  <>
                    <div className={classes.checkoutSummary}>
                      {/* <div className={classes.summaryRow}>
                          <Typography>Subtotal</Typography>
                          <Typography>
                            {commaFormat(
                              parseFloat(pricing.price) * 0.82,
                              pricing.currency.symbol
                            )}
                          </Typography>
                        </div>
                        <div className={classes.summaryRow}>
                          <Typography>IGV</Typography>
                          <Typography>
                            {commaFormat(
                              parseFloat(pricing.price) * 0.18,
                              pricing.currency.symbol
                            )}
                          </Typography>
                        </div> */}
                      <div className={classes.summaryRow}>
                        <Typography className={classes.summaryTitle}>
                          {planSelected.label}
                        </Typography>
                      </div>
                      <Divider className={classes.summaryDivider} />
                      <div className={classes.summaryRow}>
                        <Typography className={classes.semibold}>
                          Total a pagar
                        </Typography>
                        <Typography className={classes.semibold}>
                          {checkoutSummary && checkoutSummary.discount && (
                            <Typography className={classes.strikethrough}>
                              {commaFormat(
                                checkoutSummary.subtotal,
                                pricing.currency.symbol
                              )}
                            </Typography>
                          )}
                          {commaFormat(
                            checkoutSummary
                              ? checkoutSummary.total
                              : pricing.price,
                            pricing.currency.symbol
                          )}
                        </Typography>
                      </div>
                      {checkoutSummary &&
                        !!checkoutSummary.discount &&
                        !!checkoutSummary.coupon && (
                          <div className={classes.summaryRow}>
                            <Typography className={classes.discount}>
                              {checkoutSummary.coupon}
                            </Typography>
                            <Typography className={classes.discount}>
                              -(
                              {commaFormat(
                                checkoutSummary.discount,
                                pricing.currency.symbol
                              )}
                              )
                            </Typography>
                          </div>
                        )}
                      {
                        <Switch>
                          <Route exact path="/checkout">
                            <CustomTextField
                              label="¿Tienes un código de descuento?"
                              name="coupon"
                              className={classes.couponTextField}
                              InputProps={{
                                endAdornment: (
                                  <>
                                    {checkoutSummary &&
                                      !checkoutSummary.coupon &&
                                      watch('coupon') && (
                                        <CustomButton
                                          className={classes.applyCouponButton}
                                          onClick={applyCoupon}
                                        >
                                          Aplicar
                                        </CustomButton>
                                      )}
                                    {checkoutSummary &&
                                    checkoutSummary.coupon ? (
                                      <CustomButton
                                        className={classes.deleteCouponButton}
                                        endIcon={<DeleteOutlined />}
                                        onClick={deleteCoupon}
                                      >
                                        Eliminar
                                      </CustomButton>
                                    ) : null}
                                  </>
                                ),
                              }}
                              defaultValue={
                                checkoutSummary ? checkoutSummary.coupon : ''
                              }
                              InputLabelProps={{
                                className: classes.couponTextFieldLabel,
                              }}
                              error={!!errors.coupon}
                              helperText={
                                errors.coupon ? errors.coupon.message : ''
                              }
                              inputRef={register}
                              type="text"
                              disabled={isCouponApplied}
                            />
                            {checkoutSummary &&
                              (!fetchPurchaseSummaryError ||
                                fetchPurchaseSummaryError ===
                                  'Coupon not found') && (
                                <Typography
                                  className={`${classes.couponApplication} ${
                                    fetchPurchaseSummaryError &&
                                    fetchPurchaseSummaryError ===
                                      'Coupon not found'
                                      ? classes.invalidCoupon
                                      : checkoutSummary &&
                                        checkoutSummary.discount
                                      ? classes.appliedCoupon
                                      : ''
                                  }`}
                                >
                                  {fetchPurchaseSummaryError &&
                                  fetchPurchaseSummaryError ===
                                    'Coupon not found'
                                    ? 'Cupón inválido'
                                    : checkoutSummary.discount
                                    ? 'Cupón aplicado'
                                    : ''}
                                </Typography>
                              )}
                          </Route>
                        </Switch>
                      }
                    </div>
                    <Switch>
                      <Route exact path="/checkout">
                        {!!paymentProvider &&
                          paymentProvider.name !== 'STRIPE' && (
                            <FormControlLabel
                              classes={{
                                root: classes.termsNConditionsCheckbox,
                                label: classes.checkboxLabel,
                              }}
                              control={
                                <Checkbox
                                  className={classes.checkbox}
                                  checked={termsNConditions}
                                  onChange={e => {
                                    setTermsNConditions(e.target.checked);
                                  }}
                                  color="primary"
                                  disabled={disableInput}
                                />
                              }
                              label={
                                <p>
                                  Acepto{' '}
                                  <a
                                    href="https://tiendada.com/terms-conditions"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    términos y condiciones
                                  </a>
                                  .
                                </p>
                              }
                            />
                          )}
                      </Route>
                      <Route path="/checkout/payment">
                        <FormControlLabel
                          classes={{
                            root: classes.termsNConditionsCheckbox,
                            label: classes.checkboxLabel,
                          }}
                          control={
                            <Checkbox
                              className={classes.checkbox}
                              checked={termsNConditions}
                              onChange={e => {
                                setTermsNConditions(e.target.checked);
                              }}
                              color="primary"
                              disabled={disableInput}
                            />
                          }
                          label={
                            <p>
                              Acepto{' '}
                              <a
                                href="https://tiendada.com/terms-conditions"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                términos y condiciones
                              </a>
                              .
                            </p>
                          }
                        />
                      </Route>
                    </Switch>
                    {!!paymentProvider &&
                      !!store &&
                      paymentProvider.name === 'CULQI' && (
                        <CulqiPaymentButton
                          selectedCard={selectedCard}
                          paymentProvider={paymentProvider}
                          paymentSettings={{
                            title: 'TiendaDa PRO',
                            currency: pricing.currency.code || 'USD',
                            description: planSelected.label,
                            amount: checkoutSummary
                              ? checkoutSummary.total
                              : pricing.price,
                          }}
                          watch={watch}
                          onSubmit={onSubmit}
                          disabled={
                            disableInput || disableButton || !termsNConditions
                          }
                        />
                      )}
                    {!!paymentProvider &&
                      !!store &&
                      paymentProvider.name === 'PAYU_WEB' && (
                        <PayUPaymentButton
                          store={store}
                          selectedCard={selectedCard}
                          paymentProvider={paymentProvider}
                          paymentSettings={{
                            currency: pricing.currency.code || 'USD',
                            description: `TiendaDa PRO - ${planSelected.label}`,
                            planId: planSelected.id || '',
                            country: country || '',
                            amount: checkoutSummary
                              ? checkoutSummary.total
                              : pricing.price,
                          }}
                          watch={watch}
                          onSubmit={onSubmit}
                          disabled={
                            disableInput || disableButton || !termsNConditions
                          }
                        />
                      )}
                    {/* FOR CUSTOM STRIPE IMPLEMENTATION */}
                    {!!paymentProvider &&
                      !!store &&
                      paymentProvider.name === 'STRIPE' && (
                        <StripeCustomPaymentButton
                          selectedCard={selectedCard}
                          paymentProvider={paymentProvider}
                          paymentSettings={{
                            currency: pricing.currency.code || 'USD',
                            planId: planSelected.id || '',
                            country: country || '',
                            amount: checkoutSummary
                              ? checkoutSummary.total
                              : pricing.price,
                            automaticCharge: subscribe,
                            savePaymentInformation: saveInfo,
                          }}
                          watch={watch}
                          checkoutSummary={checkoutSummary}
                          isPaying={isPaying}
                          onSubmit={onSubmit}
                          disabled={disableInput || disableButton}
                          termsNConditions={termsNConditions}
                          // paymentStepAnalyticsEvent={paymentStepAnalyticsEvent}
                        />
                      )}
                    {/* PREBUILT STRIPE IMPLEMENTATION */}
                    {/* {!!paymentProvider &&
                !!store &&
                paymentProvider.name === 'STRIPE' && (
                  <StripePaymentButton
                    selectedCard={selectedCard}
                    paymentProvider={paymentProvider}
                    paymentSettings={{
                      currency: pricing.currency.code || 'USD',
                      planId: planSelected.id || '',
                      country: country || '',
                      amount: checkoutSummary
                        ? checkoutSummary.total
                        : pricing.price,
                      automaticCharge: subscribe,
                      savePaymentInformation: saveInfo,
                    }}
                    watch={watch}
                    onSubmit={onSubmit}
                    disabled={disableInput || disableButton || !termsNConditions}
                  />
                )} */}
                  </>
                )}
                {isSubscribing ? (
                  <CircularProgress style={{alignSelf: 'center'}} />
                ) : null}
              </div>
              {/* <CustomButton
                className={classes.contactButton}
                href={TIENDADA_LINKS.customerSupport.general}
                target="_blank"
                rel="noopener noreferrer"
              >
                Contáctenos para usar otro método de pago
              </CustomButton> */}
            </div>
          </>
        )}
      </div>
      <ConsentUpdateSettingModal
        open={isConsentModalOpen && !!updateSettingRequest}
        handleClose={() => setIsConsentModalOpen(false)}
        onConfirm={onUpdateSettingConfirm}
      />
      <DeleteConfirmationModal
        open={deleteModalOpen && !!cardToDelete}
        title="¿Seguro que quieres eliminar esta tarjeta?"
        content="Si eliminas la tarjeta no la podrás recuperar."
        handleClose={handleDeleteModalClose}
        handleDeleteClick={() => deleteCard({cardId: cardToDelete})}
      />
      {/* <PaymentSuccessModal
        open={paymentSuccessModal}
        handleClose={handleClosePaymentSuccessModal}
      /> */}
      <PaymentFailureModal
        programaticallyShowError
        open={paymentFailureModal}
        handleClose={() => setPaymentFailureModal(false)}
        error={subscribeError}
      />
    </div>
  );
}

Checkout.propTypes = {
  currency: PropTypes.object,
  store: PropTypes.object,
  country: PropTypes.object,
  // saveCulqiCard: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  fetchCards: PropTypes.func.isRequired,
  cardProfiles: PropTypes.array,
  isFetchingCardProfiles: PropTypes.bool,
  deleteCard: PropTypes.func.isRequired,
  fetchPurchaseSummary: PropTypes.func.isRequired,
  checkoutSummary: PropTypes.object,
  fetchPurchaseSummaryError: PropTypes.string,
  // performCulqiCheckout: PropTypes.func.isRequired,
  // isPerformingCheckout: PropTypes.bool,
  // performCheckoutSuccess: PropTypes.bool,
  // performCheckoutError: PropTypes.string,
  performSubscribe: PropTypes.func.isRequired,
  isSubscribing: PropTypes.bool,
  subscribeSuccess: PropTypes.bool,
  subscribeError: PropTypes.string,
  checkoutResetState: PropTypes.func.isRequired,
  planSelectedCurrency: PropTypes.string,
  planSelected: PropTypes.object,
  setPlanSelected: PropTypes.func,
  basicPlans: PropTypes.array,
  proPlusPlans: PropTypes.array,
  resetPlanSelected: PropTypes.func.isRequired,
  subscription: PropTypes.object,
  paymentProviders: PropTypes.array,
  user: PropTypes.object,
  saveSubscriptionSetting: PropTypes.func.isRequired,
  isSavingSubscriptionSetting: PropTypes.bool,
  saveSubscriptionSettingSuccess: PropTypes.bool,
  saveSubscriptionSettingError: PropTypes.bool,
  subscriptionSetting: PropTypes.object,
  fetchPaymentProviders: PropTypes.func.isRequired,
  setPlanSelectedCurrency: PropTypes.func.isRequired,
  isFetchingSubscriptionSetting: PropTypes.bool,
  isFetchingStore: PropTypes.bool,
};
